import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaCamera } from "react-icons/fa";
import { IoSpeedometer } from "react-icons/io5";
import { MdDateRange } from "react-icons/md";
import { GiGearStickPattern } from "react-icons/gi";
import { useNavigate } from 'react-router-dom';
import './Carlist.css';

const DelCarList = () => {
  const navigate = useNavigate();
  const [carList, setCarList] = useState([]); // State to store fetched car details
  const [loading, setLoading] = useState(true); // Manage loading state
  const [error, setError] = useState(null); // To handle API errors

  // Fetch car details from backend
  useEffect(() => {
    const fetchCars = async () => {
      try {
        const response = await axios.get('https://zoomautos.co.uk/api/cars'); // Adjust API URL if needed
        setCarList(response.data);
      } catch (error) {
        console.error('Error fetching car details:', error);
        setError('Failed to fetch car details.');
      } finally {
        setLoading(false); // Stop loading state whether success or error
      }
    };

    fetchCars();
  }, []);

  // Handle Edit
  const handleEdit = (car) => {
    navigate(`/Admin/AdminPortal/Inventory/Edit/${car._id}`, { state: { car } });
  };

  // Handle Delete
  const handleDelete = async (carId) => {
    try {
      await axios.delete(`https://zoomautos.co.uk/api/cars/${carId}`); // Adjust API URL if needed
      // Remove deleted car from the list
      setCarList((prevList) => prevList.filter((car) => car._id !== carId));
    } catch (error) {
      console.error('Error deleting car:', error);
      setError('Failed to delete car. Please try again.');
    }
  };

  // Image Gallery Component
  const ImageGallery = ({ images }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);

    if (!Array.isArray(images) || images.length === 0) return null;

    const thumbnailsToShow = images.slice(0, 5);

    return (
      <div className="images-gallery">
        <div className="imagessss-overlay">
          <FaCamera className="icon" />
          <span>{images.length}</span>
        </div>
        <img src={images[selectedImageIndex]} alt="Car" className="main-image" />
        <div className="thumbnail-container">
          {thumbnailsToShow.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className="thumbnail"
              onMouseEnter={() => setSelectedImageIndex(index)}
            />
          ))}
        </div>
      </div>
    );
  };

  // Display loading state or error
  if (loading) {
    return <div className="loading-spinner">Loading cars...</div>; // Use a spinner component
  }

  if (error) {
    return <p className="error-message">{error}</p>;
  }

  // Check if carList is empty
  if (carList.length === 0) {
    return <p>No cars available.</p>;
  }

  return (
    <div className="cars-container" style={{marginTop: '200px'}}>
      {carList.map((car) => (
        <div className="car-box" key={car._id}>
          <ImageGallery images={car.imagess} /> {/* Include the image gallery */}
          <div className="car-info-man">
            <h3 className="car-manufacturer">{car.manufacturer}</h3>
            <h4>{car.model}</h4>
            <h5>{car.variant}</h5>
            <h3>{car.attention}</h3>
            <div className="cars-infor">
              <div className="icon-text-container">
                <div className="icon-text">
                  <GiGearStickPattern className="icon" />
                  <h4>{car.transmission}</h4>
                </div>
              </div>
              <div className="icon-text-container">
                <div className="icon-text">
                  <MdDateRange className="icon" />
                  <h4>{car.year}</h4>
                </div>
              </div>
              <div className="icon-text-container">
                <div className="icon-text">
                  <IoSpeedometer className="icon" />
                  <h4>{car.mileage}</h4>
                </div>
              </div>
            </div>
          </div>
          {/* Action Buttons */}
          <div className="car-actions">
            <button className="contact-button" onClick={() => handleEdit(car)}>Edit</button>
            <button className="contact-button" onClick={() => handleDelete(car._id)}>Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DelCarList;
